import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidatorsService {

  constructor() { }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  validate(formGroup: FormGroup) {
    this.validateAllFormFields(formGroup)
    return formGroup.valid
  }

  resetField(formGroup: FormGroup, field: string) {
    formGroup.get(field).reset()
    formGroup.get(field).markAsPristine()
    formGroup.get(field).markAsUntouched()
  }

  reset(formGroup: FormGroup) {
    formGroup.reset()
    formGroup.markAsPristine()
    formGroup.markAsUntouched()
  }

  selectFirstOrDefault(control: AbstractControl, options: Array<any>, optionValuePropName: string = 'value') {
    if (options.length === 0) {
      // control.setValue(options[0][optionValuePropName])
      return
    }
    if (options.length > 0)
      control.setValue(options[0][optionValuePropName])
  }

  selectDefaultFormatoProducto(control: AbstractControl, options: Array<any>, optionValuePropName: string = 'value') {
    if (options.length === 0) return
    if (options.length > 0) {
      const defaults = options.filter(formato => formato.formato_codigo === formato.formato_codigo_top)
      if (defaults.length > 0)
        control.setValue(defaults[0][optionValuePropName])
      else
        control.setValue(options[0][optionValuePropName])
    }
  }

  setDefaultValues(formGroup: FormGroup, defaultValues: Object) {
    for (const [key, value] of Object.entries(defaultValues)) {
      formGroup.get(`${key}`).setValue(value)
      formGroup.get(`${key}`).markAsPristine()
      formGroup.get(`${key}`).markAsUntouched()
    }
  }

  setInitialState(formGroup: FormGroup, initialValues: Object) {
    formGroup.reset()
    this.setDefaultValues(formGroup, initialValues)
    formGroup.markAsPristine()
    formGroup.markAsUntouched()
  }

  obtenerValorFormHeader(formGroup: FormGroup, formControlName: string) {
    // Activar y desactivar según corresponda para obtener el valor. (desactivado el valor es null, por eso se activa antes de obtener su valor)
    const formControlState = formGroup.get(formControlName).enabled
    formGroup.get(formControlName).enable()
    const formControlValue = formGroup.get(formControlName).value
    if (formControlState)
      formGroup.get(formControlName).enable()
    else
      formGroup.get(formControlName).disable()
    return formControlValue
  }
}
